<template>
  <div ref="madeForm">
    <avue-form :option="optionForm" ref="form" v-model="formData"></avue-form>
    <span slot="dialog_footer" class="dialog-footer" v-if="!isDetails()">
      <el-button icon="el-icon-circle-plus-outline" type="primary" @click="submitForm()" :disabled="loading">提交</el-button>
      <el-button icon="el-icon-circle-close" @click="$emit('handleClose')" :disabled="loading">取消</el-button>
    </span>
  </div>
</template>

<script>
import { add, update, getDetail, uploadEndpoint } from "../api";
// import { getDetail as getCheckDetail } from "@/views/dispatch-manage/check-list/api.js";
import _ from 'lodash'
import { disposeDetail, showItem, rulesInput } from '@/basic-common/util/common.js';

export default {
  components: {},
  props: {
    transmitData: {
      required: true,
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data () {
    return {
      visible: false,
      title: '',
      show: false,
      loading: false,
      userList: [],
      formData: {
      },
      optionForm: {
        ...this.$store.state.formOption,
        submitBtn: false,
        emptyBtn: false,
        detail: this.isDetails(), //启用form详情样式
        labelWidth: 150,
        span: 24,
        addText: '新增检查项',
        column: [
          {
            label: "发生时间",
            prop: "accidentTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            rules: rulesInput(2),
            disabled: showItem(
              { add: false, edit: true, view: false },
              this.transmitData.type
            ),
          },
          {
            label: "事故类型",
            prop: "accidentType",
            dicData: this.$store.getters.commonDict['accident_type'],
            dataType: 'string',
            type: "select",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: rulesInput(2),
            disabled: showItem(
              { add: false, edit: true, view: false },
              this.transmitData.type
            ),
          },
          {
            label: "事故地点",
            prop: "accidentLocation",
            rules: rulesInput(1),
            disabled: showItem(
              { add: false, edit: true, view: false },
              this.transmitData.type
            ),
          },
          {
            label: "伤亡情况",
            prop: "casualtyDescription",
            type: "textarea",
            maxlength: 500,
            showWordLimit: true,
            minRows: 3,
            rules: rulesInput(2),
            disabled: showItem(
              { add: false, edit: true, view: false },
              this.transmitData.type
            ),
          },
          {
            label: "直接原因",
            prop: "directCause",
            maxlength: 200,
            minRows: 3,
            disabled: showItem(
              { add: false, edit: true, view: false },
              this.transmitData.type
            ),
          },
          {
            label: "上报部门",
            prop: "responsibleDepartmentId",
            type: 'tree',
            multiple: false,
            dicUrl: "/api/blade-system/dept/treeByUser",
            rules: rulesInput(2),
            props: {
              label: "deptName",
              value: "id"
            },
            disabled: showItem(
              { add: false, edit: true, view: false },
              this.transmitData.type
            ),
          },
          {
            label: "现场照片",
            prop: "imageUrl",
            type: "upload",
            drag: true,
            loadText: "文件上传中，请稍等",
            span: 24,
            propsHttp: {
              res: "data",
            },
            action: uploadEndpoint,
            accept: ".jpg,.jpeg,.png",
            beforeUpload: this.beforeImageUpload,
            disabled: showItem(
              { add: false, edit: true, view: false },
              this.transmitData.type
            ),
          },
          {
            label: "处理措施",
            prop: "processRemark",
            type: "textarea",
            maxlength: 200,
            showWordLimit: true,
            span: 24,
            minRows: 3,
            display: showItem(
              { add: false, edit: true, view: true },
              this.transmitData.type
            ),
          },
        ]
      },
      list: [],
    }
  },
  created () {
    const { type, id } = this.transmitData
    if (type != 'add') {
      this.getDetail(id)
    }
  },
  methods: {
    beforeImageUpload (file) {
      const fileName = file && file.name ? file.name.toLowerCase() : ''
      const fileType = file && file.type ? file.type.toLowerCase() : ''
      const allowExt = /\.(jpg|jpeg|png)$/.test(fileName)
      const allowMime = !fileType || ['image/jpeg', 'image/png'].includes(fileType)
      if (!allowExt || !allowMime) {
        this.$message.error('仅支持 jpg、png、jpeg 格式图片')
        return false
      }
      return true
    },
    //提交
    async submitForm () {
      const { type } = this.transmitData
      this.$refs.form.validate((valid, done) => {
        if (valid) {
          if (type == 'add') {
            add(this.formData).then(({ data }) => {
              this.$emit('handleClose', 'refresh')
              this.$message({
                type: 'success',
                message: data.msg,
              })
            }).finally(() => {
              done()
            })
          } else {
            update(this.formData).then(({ data }) => {
              this.$emit('handleClose', 'refresh')
              this.$message({
                type: 'success',
                message: data.msg,
              })
            }).finally(() => {
              done()
            })
          }
        } else {
          done()
          this.$message.error('错误, 请验证必填项并录入符合规则的数据')
        }
      })
    },
    // 回显信息初始化
    getDetail (id) {
      this.loading = true
      getDetail(id).then(res => {
        this.formData = res.data.data
        // 特殊处理详情 主表和子表， 禁用问题，悬浮提示问题。
        const topTier = this.$refs.madeForm
        this.isDetails() && disposeDetail(topTier)
      }).finally(() => {
        this.loading = false
      })

    },
    // 是否是详情
    isDetails () {
      return this.transmitData.type && this.transmitData.type == 'view'
    },
    //带出检查项
    replaceCheckList (item) {
      console.log(item.list, 'list098', item);
      this.$set(this.formData, 'list', item.list)
    },
    replace (row) {
      const replaceKey = ['planNumber', 'planName', 'checkType']
      replaceKey.forEach(item => {
        this.$set(this.formData, item, row[item])
      });
    }
  }
}
</script>
<style scoped lang="scss">
.title {
  margin: 10px 0;
  font-size: 20px;
  color: #363636;
}
</style>
